/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.css';
import { useTranslations } from "next-intl";
import { cn } from "@/utils/theme/cn";
import { Link } from '@/providers/i18n/navigation';
import Ripple from "@/components/ripple";
export default function Button(param) {
    let { onNavigate, link, id, rounded, children, className, onClick, form, title } = param;
    // hooks
    const T = useTranslations();
    // constants
    const Component = link ? Link : 'button';
    return /*#__PURE__*/ _jsxs(Component, {
        id: id,
        form: form,
        ...link ? {
            onNavigate: onNavigate,
            href: link
        } : {
            onClick: onClick
        },
        className: cn(styles.holder, rounded && styles.rounded, className),
        type: form ? 'submit' : 'button',
        children: [
            /*#__PURE__*/ _jsx(Ripple, {}),
            title && /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                children: T.has(title) ? T(title) : title
            }),
            children
        ]
    });
}
